import languageJson from './language.json';

export const dateStyle= 'en-GB';

export const language = languageJson;